import {Pagination} from '../pagination.model';
import {Customer} from '../../../../customers/shared/model/customer.model';

export class CustomerPage extends Pagination {
  content: Customer[] = [];
}
